import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Popup from "../Popup/Popup";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { CustomPopup } from "../../common/Popup/CustomPopup";
import CommonInput from "../../common/Resusable/CommonInput";
import { BrandedLinkButton, PrimaryButton, SecondaryButton } from "../../common/Buttons";

const SearchButtonGroup = ({
	updateTemplateView,
	templateView,
	templateName,
	setTemplateName,
	handleSubmit,
	handleSaveTemplate,
	templateModal,
	setTemplateModal,
	saveTempError,
	setSaveTempError,
	isModifyBooking,
	awbNo,
	setNotLeave,
	setSelectedTemplate,
	handleClear,
	stubNose,
	breedRejected,
	isSeasonalBooking,
	isMultipleBookingEdit,
	handleMutlipleBookSaveChange
}) => {
	/*for multilingual*/
	const { t, i18n } = useTranslation(["labels", "errors"]);

	const history = useHistory();
	const location = useLocation();
	const callerScreen = location.state?.callerScreen;

	const handleCancelAction = () => {
		handleClear();
		history.push("/manage-template");
	};

	const handleClosePopUp = () => {
		setTemplateModal(false);
		setTemplateName("");
		setSaveTempError(null);
	};

	const handleSaveTemplateClick = () => {
		setTemplateModal(true);
	};

	const handleBackBtn = () => {
		if (callerScreen === "ShipmentTracking") {
			history.push(`/manage-booking/${awbNo}`, {
				callerScreen: "ShipmentTracking",
			});
		} else {
			history.push(`/manage-booking/${awbNo}`);
		}
	};

	const handleClearForm = (e) => {
		handleClear();
		setSelectedTemplate("");
		setNotLeave(false);
	};

	const handleMultipleBookBackBtn = () => {
		handleClear();
		history.push("/permanent-booking");
	};


	return (
		<div className="footer-block">
			<BrandedLinkButton onClick={handleClearForm} label={t("COMMON.CLR")} isLarge />
			{isMultipleBookingEdit ? (
				<>
					<SecondaryButton
						label={t("COMMON.CANCEL")}
						onClick={handleMultipleBookBackBtn}
					/>
					<PrimaryButton
						label={t("MNGTMPLT.SAVE_CHANGES")}
						onClick={handleMutlipleBookSaveChange}
					/>
				</>
			) : (
				<>
					{!updateTemplateView && isModifyBooking && (
						<SecondaryButton
							label={t("COMMON.BACK_BUTTON")}
							onClick={handleBackBtn}
						/>
					)}

					{updateTemplateView && (
						<>
							<PrimaryButton
								label={t("MNGTMPLT.SAVE_CHANGES")}
								onClick={(e) => {
									handleSaveTemplate(false);
								}}
							/>
							<SecondaryButton
								label={t("COMMON.CANCEL")}
								onClick={handleCancelAction}
							/>
						</>
					)}
					{!templateView && !isSeasonalBooking && (
						<SecondaryButton
							label={t("BOOKING.SAVE_TEMPLATE")}
							onClick={handleSaveTemplateClick}
						/>
					)}
					{!updateTemplateView && (
						<PrimaryButton
							label={t("COMMON.CONT")}
							onClick={handleSubmit}
							disabled={stubNose}
						/>
					)}
				</>
			)}
			<CustomPopup
				isVisible={templateModal}
				footerPriBtnLabel={t("COMMON.SAVE")}
				footerSecBtnLabel={t("COMMON.CANCEL")}
				footerPriBtnClick={() => {
					handleSaveTemplate(true);
				}}
				footerSecBtnClick={handleClosePopUp}
				headerComponent={{ mainHeader: t("SAVETMPLT.SAVE_TEMPLATE") }}
				onClose={handleClosePopUp}
				body={
					<div className="form-group mb-3">
						<CommonInput
							label={t("SAVETMPLT.TMPLT_NAME_PLACEHOLDER")}
							type="text"
							value={templateName ? templateName : ""}
							onChange={(e) => {
								setSaveTempError(null);
								setTemplateName(e.target.value);
							}}
							error={
								saveTempError && saveTempError !== ""
									? t(saveTempError, { ns: "errors" })
									: ""
							}
						/>
					</div>
				}
			/>
		</div>
	);
};

export default SearchButtonGroup;
